import {Component, EventEmitter, Input, Output} from '@angular/core';
export class PromptCancelComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt-cancel',
    template: `
        <button class="btn btn-secondary">
            <ng-content></ng-content>
        </button>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PromptCancelComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptCancelComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptCancelComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
